import { createReducer, on } from '@ngrx/store';

import { CategoryTree, CategoryTreeHelper } from 'ish-core/models/category-tree/category-tree.model';

import { loadCategoryLinksSuccess, loadCategorySuccess, loadCategoryTreeSuccess, loadTopLevelCategoriesSuccess } from './categories.actions';
import { ProductLinksDictionary } from 'ish-core/models/product-links/product-links.model';

export interface CategoriesState {
  categories: CategoryTree;
  links: { [id: string]: ProductLinksDictionary };
}

const initialState: CategoriesState = {
  categories: CategoryTreeHelper.empty(),
  links: {}
};

function mergeCategories(
  state: CategoriesState,
  action: ReturnType<typeof loadCategorySuccess | typeof loadCategoryTreeSuccess | typeof loadTopLevelCategoriesSuccess>
) {
  const loadedTree = action.payload.categories;
  const categories = CategoryTreeHelper.merge(state.categories, loadedTree);
  return {
    ...state,
    categories,
  };
}

export const categoriesReducer = createReducer(
  initialState,
  on(loadCategorySuccess, loadCategoryTreeSuccess, loadTopLevelCategoriesSuccess, mergeCategories),

  on(
    loadCategoryLinksSuccess,
    (state, action): CategoriesState => ({
      ...state,
      links: { ...state.links, [action.payload.categoryId]: action.payload.links },
    })
  ),
);